import React from 'react'
import type { HeaderRowConfig } from '../../DataTable/types'
import { MenuHeaderCell } from '../../DataTable/table-header/MenuHeaderCell'

export const ListHeader = (props: HeaderRowConfig) => {
  return (
    <>
      <MenuHeaderCell />
      {props._renderDataHeaderCell()}
    </>
  )
}
